import React from "react";
import ExpenseList from "../components/ExpenseList";

const ListExpensePage = ({ expenses, deleteExpense }) => {
    return <ExpenseList expenses={expenses} deleteExpense={deleteExpense} />;
};

export default ListExpensePage;
